<template>
  <div class="fill-height">
    <TopNav />
    <div class="mt-5" style="padding-left: 15px;padding-right: 15px;">
      <div class="row">
        <div class="col-md-3 col-12 text-center">
          <img
            :src="teacher.profile_image"
            width="150"
            height="150"
            alt="user_profile"
            class="rounded-circle"
          />
        </div>
        <div class="col-md-9 col-12">
          <h2>{{ teacher.first_name }} {{ teacher.last_name }}</h2>
          <b>ตำแหน่งการทำงานปัจจุบัน</b>
          <div style="min-height: 20px" class="p-3 teacher-border">
            {{ teacher.teacher_position }}
          </div>
          <b>ตำแหน่งทางวิชาการ</b>
          <div style="min-height: 20px" class="p-3 teacher-border">
            {{ teacher.teacher_technical_position }}
          </div>
          <b>สถานที่ติดต่อ</b>
          <div style="min-height: 60px" class="p-3 teacher-border">
            {{ teacher.teacher_contact_address }}
          </div>
          <!-- <b>อีเมล</b>
          <div style="min-height: 20px" class="p-3 teacher-border">
            {{ teacher.email }}
          </div> -->
          <b>ความเชี่ยวชาญ</b>
          <div
            style="min-height: 150px"
            class="p-3 teacher-border"
            v-html="teacher.teacher_education"
          ></div>
          <b>ประวัติการทำงาน</b>
          <div
            style="min-height: 150px"
            class="p-3 teacher-border"
            v-html="teacher.teacher_work"
          ></div>
          <!-- <b>ผลงานวิจัยตีพิมพ์</b>
          <div
            style="min-height: 150px"
            class="p-3 teacher-border"
            v-html="teacher.teacher_research"
          ></div> -->
        </div>
      </div>
    </div>
    <div class="horizon-line my-3"></div>
    <div class="container">
      <b-row>
        <b-col
          v-for="item in teacher.subject"
          :key="item.id"
          md="4"
          cols="12"
          class="my-3"
        > 
        
          <CourseCard
            :id="item.id"
            :header="item.name"
            :content="item.description"
            :image="item.banner_image ? item.banner_image : noImage" 
            :register="item.enroll[0] ? 'สมัครเรียน ' + formatThaiDate(item.enroll[0].register_start) + ' - ' + formatThaiDate(item.enroll[0].register_end) : ''"
            :creator="item.creator.first_name + ' ' + item.creator.last_name"
              :creator_img="item.creator.profile_image ? item.creator.profile_image : noImage"
              :creator_position="item.creator ? item.creator.teacher_position : ''"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/topNav.vue";
import CourseCard from "@/components/CourseCard.vue";
import { mapState } from "vuex";
import noImage from "../assets/image/mock/no-image.png";
export default {
  components: {
    TopNav,
    CourseCard,
  },
  data() {
    return { noImage };
  },
  computed: {
    ...mapState({
      teacher: (state) => {
        return state.Teachers.teacher;
      },
    }),
  },
  async created() {
    await this.getContent();
  },
  methods: {
    async getContent() {
      const id = this.$route.query.id;
      await this.$store.dispatch("Teachers/getTeacher", id);
    },
    formatThaiDate(dateStr) {
      const date = new Date(dateStr);
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear() + 543;
      return `${day}/${month}/${year}`;
    }
  },
};
</script>

<style>

</style>
